import styled from 'styled-components';

export const PanelCardContainer = styled.div`
  background-color: #fff;
  width: 100%;
  .panel-card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 18px;
    border-bottom: 1px solid #e1e6eb;
    .panel-card-header-title {
      color: var(--Theme-2-950, #09305a);
      font-family: Mulish;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 30px */
    }
  }

  .panel-card-body {
    padding: 18px;

    .panel-card-body-chart-desc {
      color: var(--Theme-2-700, #627c98);
      font-family: Mulish;
      font-size: 12.5px;
      font-style: normal;
      font-weight: 800;
      line-height: 150%; /* 18.75px */
      margin-bottom: 18px;
    }

    .panel-card-error-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .panel-card-error {
        color: var(--Theme-2-950, #09305a);
        font-family: Mulish;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 21px */
        text-align: center;
      }
    }
  }
`;
